import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export function AuthCallback() {
  const { hash, pathname } = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(hash.slice(1)).get("session_id");
    api.googleSession(sid)
      .then((u) => { setUser(u); nav(pathname, { replace: true }); })
      .catch(() => { setUser(false); nav("/login?error=google", { replace: true }); });
  }, [hash, pathname, nav, setUser]);

  return <div className="auth-wait" data-testid="auth-callback" />;
}
